import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import homeButton from '../assets/images/HomeButton.jpg'; // adjust path as needed

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-links">
        <Link to="/home">
          <img 
            src={homeButton} 
            alt="Home" 
            className="home-button-image" 
          />
        </Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/T&Cs">T&Cs</Link>
      </div>
    </nav>
  );
}

export default Navbar;
